import type { BoosterDefinitions, BoosterType } from './types';

export function getBoosterUnlockedAtLevel(level: number, economyMap: BoosterDefinitions): BoosterType | undefined {
  return Object.keys(economyMap).find((key) => economyMap[key as BoosterType].unlockLevel === level) as BoosterType;
}
